import { List } from "../Components/index.js";

export default [
    {
        path: "/reports/account/final-bill/my-pending",
        component: List,
        name: "report.account.final.bill.pending",
        meta: {
            requiresAuth: true,
        },
    },
    // {path: '/reports/account/group/:id', component: GroupDetails, name: 'report.account.inventory.details'},
    // {path: '/reports/account/group-item/:id', component: Groups, name: 'report.account.inventory.group.item'},
];
